import type { ObjectType } from '@quromedical/fhir-common';
import * as yup from 'yup';

import type { PatientGeneralPractitionerUpdateRequest } from './schema';

export const generalPractitionerUpdateRequestSchema = yup.object<
  ObjectType<PatientGeneralPractitionerUpdateRequest>
>({
  organizations: yup.array(yup.string().required()).min(0).required(),
  practitioners: yup.array(yup.string().required()).min(1).required(),
});
